const faqs = [
  {
    id: 1,
    q: '91年国产影片视频需要注册才能观看吗？',
    a: '完全不需要！91年国产影片视频坚持免费开放的原则，所有91免费在线视频、91精品视频在线播放资源均无需注册即可在线观看。打开网站即可享受高清流畅的国产影片观影体验。',
  },
  {
    id: 2,
    q: '91免费视频网站支持哪些设备观看？',
    a: '我们的平台全面适配电脑、平板和手机浏览器。无论在桌面端还是移动端，91在线观看免费服务都能提供高清不缓冲的播放体验，手机端还支持91在线免费播放的投屏功能。',
  },
  {
    id: 3,
    q: '视频播放卡顿或缓冲怎么办？',
    a: '91精品视频在线播放依托全球CDN加速网络，通常情况下播放非常流畅。如果遇到卡顿，建议检查网络连接，或尝试切换清晰度。我们的平台会自动根据网速适配最佳画质，确保最佳的91免费看视频体验。',
  },
  {
    id: 4,
    q: '91麻豆免费视频网站的影片更新频率如何？',
    a: '我们保持每日更新的节奏，每天都有多部新片上线。无论是91福利在线视频专区还是其他分类频道，你都能找到最新、最热的国产影片资源，91在线免费播放的片库持续扩容中。',
  },
  {
    id: 5,
    q: '影片清晰度如何？支持哪些清晰度选择？',
    a: '91年国产影片视频提供标清、高清和超清三种清晰度选择，用户可根据网络状况和观影需求自由切换。绝大多数91精品视频在线播放资源均以高清及以上画质呈现，确保视觉体验。',
  },
  {
    id: 6,
    q: '网站是否安全？观影记录会被记录吗？',
    a: '91免费视频网站高度重视用户隐私保护。我们不强制注册账号，也不会追踪用户的观影记录。所有91在线观看免费服务均采用匿名访问模式，你可以放心地享受91免费看视频的乐趣。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="section-scroll py-14 md:py-20 bg-gray-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-red-600 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2">答疑解惑</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">常见问题</h2>
          <p className="mt-2 text-gray-500 text-sm md:text-base max-w-lg mx-auto">
            关于91年国产影片视频的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-white rounded-xl border border-gray-100 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <h3 className="text-sm md:text-base font-semibold text-gray-900 flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 md:w-7 md:h-7 rounded-lg bg-red-50 flex items-center justify-center mt-0.5">
                    <i className="ri-question-line text-red-600 text-xs md:text-sm"></i>
                  </span>
                  {faq.q}
                </h3>
              </div>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-gray-600 leading-relaxed pl-9 md:pl-10">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}